
import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { useLocation } from "react-router-dom";
import { createBooking } from "../api/auth/booknowService";

function Booknow() {
    const location = useLocation();
    const plan = location.state?.plan;

    const [values, setValues] = React.useState({
        clinicname: "",
        name: "",
        email: "",
        phone: "",
        websitename: "",
        address: "",
        date: "",
    });

    const handleChanges = (e) => {
        const { name, value } = e.target;
        setValues({
            ...values,
            [name]: value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const currentDate = new Date().toISOString().split("T")[0];

        const payload = {
            plan_name: plan?.plantype,
            price: plan?.price,
            clinicname: values.clinicname,
            name: values.name,
            phone: values.phone,
            email: values.email,
            websitename: values.websitename,
            address: values.address,
            date: currentDate,
        };

        try {
            const response = await createBooking(payload);
            console.log(response);
            alert("Booking saved successfully!");

            setValues({
                HospitalName: "",
                name: "",
                email: "",
                phone: "",
                websitename: "",
                address: "",
                message: "",
                date: "",
            });
        } catch (error) {
            console.error("Error saving booking:", error);
            alert("Failed to save booking");
        }
    };



    return (
        <div>
            <Header />
            <div className="breadcrumbs overlay">
                <div className="container">
                    <div className="bread-inner">
                        <div className="row">
                            <div className="col-12">
                                <h2>Book Now</h2>
                                <ul className="bread-list">
                                    <li><a href="/">Home</a></li>
                                    <li><i className="icofont-simple-right" /></li>
                                    <li className="active">Book Now</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <section className="appointment" >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-md-12 mb-4">
                            <div className="appointment-image text-center">
                                <img
                                    src="img/Book.png"
                                    alt="Book Now"
                                    className="img-fluid book-img"
                                />

                                {/* Content below image */}
                                <div className="book-content mt-3">
                                    <h4 className="fw-bold">Book Your subscription Today</h4>
                                    <p>
                                        Choose a subscription plan that fits your needs. Our subscription includes website maintenance, technical support, security updates, and performance optimization to keep your online presence running smoothly.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-6 col-md-12 col-12">
                            <form className="form" onSubmit={handleSubmit}>
                                <div className="mb-1">
                                    <label className="fw-bold">Plan Name:- {plan?.plantype}</label>

                                </div>
                                <div className="mb-1">
                                    <label className="fw-bold">Price:- ₹{plan?.price}</label>

                                </div>

                                <div className="row">
                                    <div className="col-md-6 mb-3">
                                        <input
                                            name="clinicname"
                                            type="text"
                                            className="form-control"
                                            placeholder="Clinic/Hospital Name"
                                            onChange={handleChanges}
                                            value={values.clinicname}
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <input
                                            name="name"
                                            type="text"
                                            className="form-control"
                                            placeholder="Your Name"
                                            onChange={handleChanges}
                                            value={values.name}
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <input
                                            name="phone"
                                            type="text"
                                            className="form-control"
                                            placeholder="MobileNo"
                                            onChange={handleChanges}
                                            value={values.phone}
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <input
                                            name="email"
                                            type="email"
                                            className="form-control"
                                            placeholder="Email"
                                            onChange={handleChanges}
                                            value={values.email}
                                        />
                                    </div>
                                    <div className="col-12 mb-3">
                                        <input
                                            name="websitename"
                                            type="text"
                                            className="form-control"
                                            placeholder="Clinic/Hospital Website"
                                            onChange={handleChanges}
                                            value={values.websitename}
                                        />
                                    </div>
                                    <div className="col-12 mb-3">
                                        <input
                                            name="address"
                                            type="text"
                                            className="form-control"
                                            placeholder="Address"
                                            onChange={handleChanges}
                                            value={values.address}
                                        />
                                    </div>
                                </div>

                                <div className="d-flex justify-content-start mb-3 ">
                                    <button type="submit" className="btn btn-primary">
                                        Book Now
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />

        </div>
    );
}

export default Booknow;

